import React from 'react';
import StaticPage from '../components/layout/StaticPage';

export default function ContactUs() {
    return (
        <StaticPage title="Get in Touch" description="Contact Host-it support for help with your party rental bookings or account.">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center not-prose">
                <div>
                    <p className="text-lg mb-6 text-gray-600">
                        Have questions, feedback, or need support? We're here to help make your event planning seamless.
                    </p>
                    <div className="space-y-6">
                        <div className="flex items-center space-x-4 p-4 bg-gray-50 rounded-lg">
                            <span className="bg-pink-100 p-3 rounded-full text-pink-600 text-xl">✉️</span>
                            <div>
                                <p className="text-sm text-gray-500 font-bold uppercase">Email Us</p>
                                <a href="mailto:support@cacti-interactive.com" className="text-lg font-medium text-gray-900 hover:text-pink-600 transition">support@cacti-interactive.com</a>
                            </div>
                        </div>
                        <div className="flex items-center space-x-4 p-4 bg-gray-50 rounded-lg">
                            <span className="bg-pink-100 p-3 rounded-full text-pink-600 text-xl">📍</span>
                            <div>
                                <p className="text-sm text-gray-500 font-bold uppercase">Location</p>
                                <span className="text-lg font-medium text-gray-900">Simi Valley, CA</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="bg-gradient-to-br from-pink-50 to-purple-50 p-8 rounded-2xl border border-pink-100">
                    <h3 className="font-bold text-2xl mb-4 text-gray-800">Support Hours</h3>
                    <div className="space-y-3 text-gray-700">
                        <p className="flex justify-between border-b border-pink-200 pb-2"><span>Monday - Friday</span> <span className="font-semibold">9am - 5pm PST</span></p>
                        <p className="flex justify-between border-b border-pink-200 pb-2"><span>Saturday</span> <span className="font-semibold">10am - 2pm PST</span></p>
                        <p className="flex justify-between text-gray-500 italic"><span>Sunday</span> <span>Closed</span></p>
                    </div>
                    <p className="mt-6 text-sm text-gray-500">For urgent booking issues on weekends, please use the emergency contact number provided in your booking confirmation.</p>
                </div>
            </div>
        </StaticPage>
    );
}